export class InitiateSigningModel {
  studentId: number;
  contact: string;
  studentConsentId: number;
  consentId: number;
  locationId: number;
  encryptedData: string;
  backofficeApplication: boolean = false;
}
